export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7203.3250fa94.jpg";